import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { renderSections } from "./util";
export const CheckoutStep = ({ data, state, sections, options, }) => _jsx(_Fragment, { children: renderSections(sections, data, state, options) });
